import { render } from "./TheExchangeTitle.vue?vue&type=template&id=27914896"
import script from "./TheExchangeTitle.vue?vue&type=script&lang=js"
export * from "./TheExchangeTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__